import { render, staticRenderFns } from "./GalleryFilters.vue?vue&type=template&id=8bb3b0a0&scoped=true&"
import script from "./GalleryFilters.vue?vue&type=script&lang=js&"
export * from "./GalleryFilters.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/filters.css?vue&type=style&index=0&id=8bb3b0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb3b0a0",
  null
  
)

export default component.exports